module.exports = __webpack_public_path__ + "img/Bioreactor_The_Scarab_4F.STUDIO_.6066613d.webp";